
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn/[id]",
      function () {
        return require("private-next-pages/learn/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learn/[id]"])
      });
    }
  